import { makeCollectionQuery, makeApiMutation } from "@web-monorepo/fetchers";
import { sortBy } from "es-toolkit/compat";
import { useMemo } from "react";

export const useToolsFetcher = makeCollectionQuery({
  fetcherName: "toolkitTools",
  path: "/api/dojoClass/{classId}/tool",
});

export const useCreateToolMutation = makeApiMutation({
  name: "createTool",
  path: "/api/dojoClass/{classId}/tool",
  method: "post",
  onSuccess: () => {
    useToolsFetcher.invalidateQueries();
  },
});

export const useEditToolMutation = makeApiMutation({
  name: "editTool",
  path: "/api/dojoClass/{classId}/tool/{id}",
  method: "put",
  onSuccess: () => {
    useToolsFetcher.invalidateQueries();
  },
});

export const useDeleteToolMutation = makeApiMutation({
  name: "deleteTool",
  path: "/api/dojoClass/{classId}/tool/{id}",
  method: "delete",
  onSuccess: () => {
    useToolsFetcher.invalidateQueries();
  },
});

export function useToolsByType(classId: string, type: string, options?: { enabled?: boolean }) {
  const { data: tools, ...rest } = useToolsFetcher({ classId }, { enabled: options?.enabled });

  const filtered = useMemo(() => {
    if (!tools) return undefined;
    return sortBy(
      tools.filter((tool) => tool.type === type),
      "updatedAt",
    ).reverse();
  }, [tools, type]);

  return { data: filtered, ...rest };
}
